export function paddingVertical(value) {
  if (value === undefined) {
    return {};
  }
  return {
    paddingTop: value,
    paddingBottom: value
  };
}
export function paddingHorizontal(value) {
  if (value === undefined) {
    return {};
  }
  return {
    paddingLeft: value,
    paddingRight: value
  };
}
export function marginVertical(value) {
  if (value === undefined) {
    return {};
  }
  return {
    marginTop: value,
    marginBottom: value
  };
}
export function marginHorizontal(value) {
  if (value === undefined) {
    return {};
  }
  return {
    marginLeft: value,
    marginRight: value
  };
}